import React, { Fragment } from 'react'

import styles from './SlideOverModal.module.css'
import CloseIcon from 'Icons/close.svg'
import Heading from 'Design/components/Heading'

const SlideOverModal = (props) => {
  const { title, onHide, children } = props

  return (
    <Fragment>
      <div className={styles.Overlay} onClick={onHide} />
      <div className={styles.Container}>
        <div className={styles.Header}>
          <div className={styles.Close} onClick={onHide}>
            <CloseIcon widht='18' height='18' />
          </div>
          <Heading level={2}>{title}</Heading>
        </div>
        <div className={styles.Content}>{children}</div>
      </div>
    </Fragment>
  )
}

export default SlideOverModal
